import { useState } from 'react';

// The message search control (T-0200: moved into the header row proper). Owns its
// own open/query state and reports changes upward; the thread does the filtering.
// aria-labels are unchanged from its previous home in SpaceView so existing specs
// keep resolving it by role + name.

export function MessageSearchBar({
  onQueryChange,
}: {
  onQueryChange: (q: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');

  function handleToggle() {
    if (open) {
      setQuery('');
      onQueryChange('');
      setOpen(false);
    } else {
      setOpen(true);
    }
  }

  function handleChange(value: string) {
    setQuery(value);
    onQueryChange(value);
  }

  function handleClear() {
    setQuery('');
    onQueryChange('');
  }

  return (
    <div className="message-search">
      <button
        type="button"
        className="message-search-toggle btn-secondary"
        onClick={handleToggle}
        aria-expanded={open}
        aria-label={open ? 'Close search' : 'Search messages'}
      >
        <span aria-hidden="true">{open ? '✕' : '🔍'}</span>
        <span className="message-search-toggle-label">{open ? 'Close' : 'Search'}</span>
      </button>
      {open && (
        <div className="message-search-bar" role="search">
          <input
            type="search"
            className="message-search-input"
            value={query}
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search messages…"
            aria-label="Search messages"
            autoFocus
          />
          {query && (
            <button
              type="button"
              className="message-search-clear btn-secondary"
              onClick={handleClear}
              aria-label="Clear search"
            >
              Clear
            </button>
          )}
        </div>
      )}
    </div>
  );
}
